<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="contact" />
  <SiteBreadcrumb />

  <div id="content" class="site-content">
    <article class="contact-article">
      <section class="contact-content">
        <header class="contact-header">
          <h1>Contact Us</h1>
        </header>

        <p>
          We appreciate your interest in GBAppZe! Whether you have a question, suggestion, or feedback about our GBWhatsApp content, we're here to help.
        </p>

        <section class="section">
          <h2>How to Reach Us</h2>
          <p>For general inquiries, partnership opportunities, or content feedback, please email us at <strong>support@gbappze.com</strong>.</p>
        </section>

        <section class="section">
          <h2>What We Do</h2>
          <p>GBAppZe focuses exclusively on <strong>sharing information about GBWhatsApp features, updates, and safe usage tips</strong>. We do not provide downloads or official app files — our goal is to inform users responsibly and clearly.</p>
        </section>

        <section class="section">
          <h2>Response Time</h2>
          <p>Our team reviews all messages and typically responds within <strong>48 hours</strong>. If your message involves a technical issue, please include your device type and a brief description to help us assist you better.</p>
        </section>

        <section class="section">
          <h2>Note</h2>
          <p>We are not affiliated with WhatsApp Inc. or the GBWhatsApp development team. All guidance shared on GBAppZe is purely informational.</p>
        </section>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ContactUs',
  components: { HeadNav },
};
</script>

<style scoped>
.contact-article {
  display: block;
}

.contact-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.contact-header {
  text-align: center;
  margin-bottom: 24px;
}

.section {
  margin: 24px 0;
}

.section p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .contact-content {
    padding: 16px;
    margin: 1rem auto;
  }
}
</style>

